import React, { useState } from "react";
import AwardIcon from "assets/images/svgs/award-icon.svg";
import useStore from "hooks/useStore";
import useAmbassador from "containers/ambassador/useHooks";

const PointAllocation = () => {
  const [activeTab, setActiveTab] = useState("Tier 1");
  const [notificationsEnabled, setNotificationsEnabled] = useState(true);
  const tabs = ["Tier 1", "Tier 2", "Tier 3"];
  const { getAmbassadorTier } = useStore()
  const tier = getAmbassadorTier();
  const tierMap = {
    tierOne: "Tier 1",
    tierTwo: "Tier 2",
    tierThree: "Tier 3",
  };
  const subscribedTier = tierMap[tier];
  const {updateAmbassadorTier} = useAmbassador()


  const tier1Engagement = [
    {
      heading: "Monthly Time Commitment",
      items: ["~ 5–6 hours"],
    },
    {
      heading: "Social Media Activity",
      items: [
        "Posts: 1 original post",
        "Shares: 2 shares of Learn Local content",
      ],
    },
    {
      heading: "Business Engagement",
      items: [
        "Photo of New Business Commitment: 1 photo (business that verbally commits to join Learn Local)",
        "Business Registration Goal: Help 1 business complete its profile",
        "Support for Experience Creation: 1 initial consultation or support session",
        "Follow-Up After Experience: Follow up with 1 business",
      ],
    },
  ];
  const tier1Family = [
    "New Family Registration: Encourage 1 family to register on the app.",
    "Sign-Up for Experience: Encourage 1 family to sign up for an experience.",
  ];

  const tier2Engagement = [
    {
      heading: "Monthly Time Commitment",
      items: ["~10–15 hours"],
    },
    {
      heading: "Social Media Activity",
      items: [
        "Posts: 2 original posts",
        "Shares: 3 shares of Learn Local content",
      ],
    },
    {
      heading: "Business Engagement",
      items: [
        "Photo of New Business Commitment: 2 photos",
        "Business Registration Goal: Assist 2 businesses with profile completion",
        "Experience Creation Coaching: Provide support to 1–2 businesses on posting an experience",
        "Follow-Up After Experience: Follow up with 2 businesses",
        "Business Review Request: Request 1–2 reviews from businesses",
      ],
    },
    {
      heading: "Event Support",
      items: ["Learn Local Event Attendance: Attend 1 event"],
    },
  ];

  const tier2Family = [
    {
      items: [
        "New Family Registration: Encourage 2 families to register",
        "Sign-Up for Experience: Motivate 2 families to participate",
        "Review Request: Ask 1 family or business to write a review of the ambassador or Learn Local",
      ],
    },
  ];

  const tier3Engagement = [
    {
      heading: "Monthly Time Commitment",
      items: ["~15+ hours"],
    },
    {
      heading: "Social Media Activity",
      items: [
        "Posts: 3 original posts, including photos/videos from experiences",
        "Shares: 4 shares of Learn Local content",
      ],
    },
    {
      heading: "Business Engagement",
      items: [
        "Photo of New Business Commitment: 3 photos",
        "Business Registration Goal: Assist 3+ businesses with profile setup and completion",
        "Experience Creation Coaching: Guide 3 businesses on posting experiences",
        "Follow-Up After Experience: Follow up with 3 businesses",
        "Business Review Request: Request 3+ reviews from businesses",
      ],
    },
    {
      heading: "Event Support",
      items: [
        "Learn Local Event Attendance: Attend 1 event and volunteer",
        "Volunteer Role: Participate actively in planning or facilitating the event",
      ],
    },
  ];

  const tier3Family = [
    {
      items: [
        "New Family Registration: Encourage 3 families to join",
        "Sign-Up for Experience: Encourage 3 families to sign up for an experience",
        "Review Request: Ask 2–3 families or businesses to write a review",
      ],
    },
  ];


  const handleSubmit = (tiertype: string) => {
    updateAmbassadorTier({tier:tiertype})
  }



  const toggleNotifications = () => {
    setNotificationsEnabled(!notificationsEnabled);
  };

  return (
    <div className="p-6">
      <h2 className="text-2xl font-semibold text-blackie mb-6">
        Tier Level & Milestones
      </h2>

      <div className="flex space-x-4 mb-4">
        {tabs.map((tab) => (
          <button
            key={tab}
            className={`text-sm font-semibold px-4 py-2 ${activeTab === tab
              ? "text-yellowText border-b-2 border-yellowText"
              : "text-gray-500"
              }`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {activeTab === "Tier 1" && (
        <div className="bg-white rounded-lg border-0 p-6">
          <div className="flex items-start justify-between flex-wrap gap-4 mb-6 flex-col">
            <div className="flex items-center gap-4 flex-wrap">
              <div className="flex items-center bg-[#37588A] text-white px-6 py-3 rounded-xl space-x-4 min-w-[300px]">
                <div className="text-lg">
                  <img src={AwardIcon} alt="AwardIcon" />
                </div>
                <div className="flex items-end gap-4">
                  <div className="text-left leading-tight">
                    <div className="text-sm font-semibold">Tier 1</div>
                    <div className="text-sm">Community Builder</div>
                  </div>
                  <div className="text-xs text-white/70 ml-2">
                    (Minimum Engagement)
                  </div>
                </div>
              </div>
              <button
                onClick={() => handleSubmit ("tierOne")}
                disabled={activeTab === subscribedTier}
                className={`bg-[#F3F5F6] px-10 py-5 text-[#2C4657] rounded-full ${activeTab === subscribedTier
                 ? "bg-gray-400 cursor-not-allowed"
                  : "bg-[#F3F5F6]"
                  }`}
              >
                {activeTab === subscribedTier ? "Subscribed" : "Subscribe"}
              </button>

            </div>
          </div>
          <p className="text-gray-700 mb-6 max-w-lg">
            Make meaningful contributions with small, consistent efforts that build connections and spread the Learn Local message.
          </p>

          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <h3 className="font-semibold text-black mb-2">Minimum Engagement:</h3>
              <div className="space-y-4 text-gray-800">
                {tier1Engagement.map((section, index) => (
                  <div key={index}>
                    <p className="font-semibold">{section.heading}</p>
                    <ul className="list-disc list-inside space-y-1 ml-4">
                      {section.items.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
              <p className="text-gray-600 mt-4">Earn 10% bonus every month for completing a task from each category</p>
            </div>


            <div>
              <h3 className="font-semibold text-black mb-2">
                Family Engagement
              </h3>
              <ul className="list-disc list-inside text-gray-800 space-y-1">
                {tier1Family.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      )}
      {activeTab === "Tier 2" && (
        <div className="bg-white rounded-lg border-0 p-6">
          <div className="flex items-start justify-between flex-wrap gap-4 mb-6 flex-col">
            <div className="flex items-center gap-4 flex-wrap">
              <div className="flex items-center bg-[#37588A] text-white px-6 py-3 rounded-xl space-x-4 min-w-[300px]">
                <div className="text-lg">
                  <img src={AwardIcon} alt="AwardIcon" />
                </div>
                <div className="flex items-end gap-4">
                  <div className="text-left leading-tight">
                    <div className="text-sm font-semibold">Tier 2</div>
                    <div className="text-sm">Community Advocate</div>
                  </div>
                  <div className="text-xs text-white/70 ml-2">
                    (Moderate Engagement)
                  </div>
                </div>
              </div>
              <button
               onClick={() => handleSubmit ("tierTwo")}
                disabled={activeTab === subscribedTier}
                className={`bg-[#F3F5F6] px-10 py-5 text-[#2C4657] rounded-full ${activeTab === subscribedTier
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-[#F3F5F6]"
                  }`}
              >
                {activeTab === subscribedTier ? "Subscribed" : "Subscribe"}
              </button>
            </div>
          </div>

          <p className="text-gray-700 mb-6 max-w-lg">
            Play a key role in shaping local learning experiences and inspiring deeper connections within your community.
          </p>

          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <h3 className="font-semibold text-black mb-2">Moderate Engagement:</h3>
              <div className="space-y-4 text-gray-800">
                {tier2Engagement.map((section, index) => (
                  <div key={index}>
                    <p className="font-semibold">{section.heading}</p>
                    <ul className="list-disc list-inside space-y-1 ml-4">
                      {section.items.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
              <p className="text-gray-600 mt-4">Earn 12% bonus every month for completing a task from each category</p>
            </div>
            <div>
              <h3 className="font-semibold text-black mb-2">Family Engagement</h3>
              <div className="space-y-4 text-gray-800">
                {tier2Family.map((section, index) => (
                  <div key={index}>
                    <ul className="list-disc list-inside space-y-1 ml-4">
                      {section.items.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>

          </div>
        </div>
      )}
      {activeTab === "Tier 3" && (
        <div className="bg-white rounded-lg border-0 p-6">
          <div className="flex items-start justify-between flex-wrap gap-4 mb-6 flex-col">
            <div className="flex items-center gap-4 flex-wrap">
              <div className="flex items-center bg-[#37588A] text-white px-6 py-3 rounded-xl space-x-4 min-w-[300px]">
                <div className="text-lg">
                  <img src={AwardIcon} alt="AwardIcon" />
                </div>
                <div className="flex items-end gap-4">
                  <div className="text-left leading-tight">
                    <div className="text-sm font-semibold">Tier 3</div>
                    <div className="text-sm">Community Leader</div>
                  </div>
                  <div className="text-xs text-white/70 ml-2">
                    (High Engagement)
                  </div>
                </div>
              </div>
              <button
               onClick={() => handleSubmit ("tierThree")}
                disabled={activeTab === subscribedTier}
                className={`bg-[#F3F5F6] px-10 py-5 text-[#2C4657] rounded-full ${activeTab === subscribedTier
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-[#F3F5F6]"
                  }`}
              >
                {activeTab === subscribedTier ? "Subscribed" : "Subscribe"}
              </button>
            </div>
          </div>
          <p className="text-gray-700 mb-6 max-w-lg">
            Take the lead in driving community transformation, mentoring others, and making a lasting impact through Learn Local.
          </p>
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <h3 className="font-semibold text-black mb-2">High Engagement:</h3>
              <div className="space-y-4 text-gray-800">
                {tier3Engagement.map((section, index) => (
                  <div key={index}>
                    <p className="font-semibold">{section.heading}</p>
                    <ul className="list-disc list-inside space-y-1 ml-4">
                      {section.items.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
              <p className="text-gray-600 mt-4">Earn 15% bonus every month for completing a task from each category</p>
            </div>
            <div>
              <h3 className="font-semibold text-black mb-2">Family Engagement</h3>
              <div className="space-y-4 text-gray-800">
                {tier3Family.map((section, index) => (
                  <div key={index}>
                    <ul className="list-disc list-inside space-y-1 ml-4">
                      {section.items.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>

          </div>
        </div>
      )}
    </div>
  );
};

export default PointAllocation;
